import React, { HTMLAttributes } from 'react';

import { Container } from './styles';

type TabPanelProps = HTMLAttributes<HTMLDivElement> & {
  index: number;
  selectedTab: number;
};

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  selectedTab,
  index,
  ...rest
}) => {
  return (
    <Container hidden={selectedTab !== index} {...rest}>
      {children}
    </Container>
  );
};

export default TabPanel;
